import React from "react";
import css from "./style.scss";
import classNames from "classnames";
import formatDate from "../../../utils/date/formatDate";
import { Link as RouterLink, withRouter } from "react-router-dom";
import { campaignPath } from "app/routes";

const CampaignTable = ({ data, type, campaignId, history }) => {

  const isEmail = type?.code === "EMAIL";

  return (
    <div className={css.campaignTableContainer}>
      <div className={css.tableWrapper}>
        <table className={css.table}>
          <thead>
            <tr>
              <th>Title</th>
              <th>Status</th>

              {isEmail ? (
                <>
                  <th>Order Number</th>
                  <th>Last Edited</th>
                  <th>Sent</th>
                  <th>Click-throughs</th>
                </>
              ) : (
                <>
                  <th>Progress</th>
                  <th>Leads Contacted</th>
                  <th>Total Leads</th>
                  <th>Started</th>
                  <th>Last Called</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {data.map(({ item, isDialer, isActive, active }, index) => (
              <tr
                key={index}
                className={css.clickableRow}
                onClick={() => {
                  history.push({
                    pathname: campaignPath(
                      `${campaignId}/${type?.route || ""}/${item.get("id")}`
                    ),
                    state: { dialerItem: item }
                  });
                }}
              >
                <td>{item.get("name")}</td>

                <td>
                  <span
                    className={classNames(
                      css.status,
                      active ? css.active : css.inactive
                    )}
                  >
                    {isDialer
                      ? (isActive ? "Active" : "Inactive")
                      : (item.get("publishDate") ? "Published" : "Unpublished")}
                  </span>
                </td>

                {isEmail ? (
                  <>
                    <td>{item.get("id")}</td>

                    <td>
                      {item.get("updateDate")
                        ? formatDate(item.get("updateDate"))
                        : "—"}
                    </td>

                    <td>{item.get("deliveredQuantity") || 0}</td>

                    <td>{item.get("clickQuantity") || 0}</td>
                  </>
                ) : (
                  <>
                    <td>
                      {(() => {
                        const contactedCount = item.get("deliveredQuantity");
                        const recipientTotal = item.get("recipientTotal");

                        if (
                          !isNaN(contactedCount) &&
                          !isNaN(recipientTotal) &&
                          recipientTotal > 0
                        ) {
                          return `${Math.floor(
                            contactedCount / recipientTotal * 100
                          )}%`;
                        }

                        return "0%";
                      })()}
                    </td>

                    <td>{item.get("deliveredQuantity") || 0}</td>
                    <td>{item.get("recipientTotal") || 0}</td>

                    <td>
                      {item.get("startDate")
                        ? formatDate(item.get("startDate"))
                        : "—"}
                    </td>

                    <td>
                      {item.get("lastCallDate")
                        ? formatDate(item.get("lastCallDate"))
                        : "—"}
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default withRouter(CampaignTable);